module.exports = __webpack_public_path__ + "img/logo.asset.2a6850a5.svg";